<div id="adding-area">
  <div id="adding-area-container">
    <div id="adding-area-content" class="border-like-dx {{isAddAreaCollapsed ? 'collapsed' : ''}}">
      <dx-tab-panel (onTitleClick)="onTabChange($event)">
        <dxi-item title="Offre alimentaire">
          <div class="line">
            <yo-tagbox
              [data]="hierarchy?.offresAlimentaire"
              [selectedItems]="selectedOffreAlimentaireList"
              (onValueChange)="updateValueOffreAlimentaire($event, cellTypes.OFFRE_ALIMENTAIRE)"
              placeholder="Offre alimentaire">
            </yo-tagbox>
            <yo-tagbox
              [data]="prestationList"
              [selectedItems]="selectedPrestationList"
              (onValueChange)="updateValueOffreAlimentaire($event, cellTypes.PRESTATION)"
              [disabled]="!isParentSelected(selectedOffreAlimentaireList)"
              placeholder="Prestation">
            </yo-tagbox>
            <yo-tagbox
              [data]="repasList"
              [selectedItems]="selectedRepasList"
              (onValueChange)="updateValueOffreAlimentaire($event, cellTypes.REPAS)"
              [disabled]="!isParentSelected(selectedPrestationList)"
              placeholder="Repas">
            </yo-tagbox>
          </div>
          <div class="line">
            <yo-tagbox
              [data]="regimeList"
              [selectedItems]="selectedRegimeList"
              (onValueChange)="updateValueOffreAlimentaire($event, cellTypes.REGIME)"
              [disabled]="!isParentSelected(selectedPrestationList)"
              placeholder="Régime">
            </yo-tagbox>
            <yo-tagbox
              [data]="pointFacturationList"
              [selectedItems]="selectedPointFacturationList"
              (onValueChange)="updateValueOffreAlimentaire($event, cellTypes.POINT_FACTURATION)"
              [disabled]="!isParentSelected(selectedPrestationList)"
              placeholder="Point de facturation">
            </yo-tagbox>
            <yo-tagbox
              [data]="pointLivraisonList"
              [selectedItems]="selectedPointLivraisonList"
              (onValueChange)="updateValueOffreAlimentaire($event, cellTypes.POINT_LIVRAISON)"
              [disabled]="!isParentSelected(selectedPointFacturationList)"
              placeholder="Point de livraison">
            </yo-tagbox>
          </div>
        </dxi-item>
        <dxi-item title="Client"
                  onClick="onTabChange($event)">
          <div class="line">
            <yo-tagbox
              [data]="pointFacturationList"
              [selectedItems]="selectedPointFacturationList"
              (onValueChange)="updateValueClient($event, cellTypes.POINT_FACTURATION)"
              placeholder="Point de facturation">
            </yo-tagbox>
            <yo-tagbox
              [data]="pointLivraisonList"
              [selectedItems]="selectedPointLivraisonList"
              (onValueChange)="updateValueClient($event, cellTypes.POINT_LIVRAISON)"
              [disabled]="!isParentSelected(selectedPointFacturationList)"
              placeholder="Point de livraison">
            </yo-tagbox>
            <yo-tagbox
              [data]="offreAlimentaireList"
              [selectedItems]="selectedOffreAlimentaireList"
              (onValueChange)="updateValueClient($event, cellTypes.OFFRE_ALIMENTAIRE)"
              [disabled]="!isParentSelected(selectedPointLivraisonList)"
              placeholder="Offre alimentaire">
            </yo-tagbox>
          </div>
          <div class="line">
            <yo-tagbox
              [data]="prestationList"
              [selectedItems]="selectedPrestationList"
              (onValueChange)="updateValueClient($event, cellTypes.PRESTATION)"
              [disabled]="!isParentSelected(selectedOffreAlimentaireList)"
              placeholder="Prestation">
            </yo-tagbox>
            <yo-tagbox
              [data]="repasList"
              [selectedItems]="selectedRepasList"
              (onValueChange)="updateValueClient($event, cellTypes.REPAS)"
              [disabled]="!isParentSelected(selectedPrestationList)"
              placeholder="Repas">
            </yo-tagbox>
            <yo-tagbox
              [data]="regimeList"
              [selectedItems]="selectedRegimeList"
              (onValueChange)="updateValueClient($event, cellTypes.REGIME)"
              [disabled]="!isParentSelected(selectedPrestationList)"
              placeholder="Régime">
            </yo-tagbox>
          </div>
        </dxi-item>
      </dx-tab-panel>

      <div class="line custom-button-container-right">
        <yo-button
          iconClass="fa fa-save"
          label="Ajouter"
          tooltip="Ajouter les lignes de paramétrage"
          [theme]="ButtonThemeEnum.SAVE"
          [disabled]="!isReadyToAdd()"
          (onClick)="addLignesParametrage()">
        </yo-button>
        <yo-button
          iconClass="fa fa-times"
          tooltip="Réduire la zone d'ajout de lignes de paramétrage"
          label="Fermer"
          [theme]="ButtonThemeEnum.CANCEL"
          (onClick)="reduceAddArea()">
        </yo-button>
      </div>
    </div>
  </div>
</div>
